class DigitalPayPaymentErrorStateException {
    constructor(message) {
        this.message = message;
        this.name = 'DigitalPayPaymentErrorStateException';
    }
}

module.exports = DigitalPayPaymentErrorStateException;



// WEBPACK FOOTER //
// ./src/digitalpay/services/digital-pay-payment-error-state.exception.js